import React from "react"

import "@/styles/component/textarea.scss"

type Props = {
  name: string,
  placeholder?: string,
  register?: any,
  errors?: any,
}
const Textarea: React.FC<Props> = ({ name, placeholder = "入力してください", register, errors }) => (
  <textarea placeholder={placeholder} className={`textarea ${errors[name] ? "error" : ""}`} name={name} ref={register({ required: true })}></textarea>
)

export default Textarea
